export enum Plan {
  TEST_ACCOUNT = 'test_account',
  STARTER = 'starter',
  BUSINESS = 'business',
  ENTERPRISE = 'enterprise',
}
